"use client";

import { themeRootClassMap } from "apps/website/maps/Theme.map";

import SectionImageSplash from "../../section/SectionSplash/SectionImageSplash/SectionImageSplash";
import Grid from "../../layout/Grid/Grid";
import Button from "../../base/Button/Button";
import Section from "../../layout/Section/Section";
import Container from "../../layout/Container/Container";
import Column from "../../layout/Column/Column";
import SectionAnimatedSplit from "../../section/SectionAnimatedSplit/SectionAnimatedSplit";
import SectionBrandComparisonTableLandingPageTest from "../../section/SectionBrandComparisonTableLandingPageTest/SectionBrandComparisonTableLandingPageTest";

import SectionQualityOrigins from "./sections/SectionQualityOrigins";
import SectionHowItWorks from "./sections/SectionHowItWorks";
import SectionFreeTrial from "./sections/SectionFreeTrial";
import SectionFAQ from "./sections/SectionFAQ";
import SectionCatsAreCarnivoresVariant from "./sections/SectionCatsAreCarnivores/variant";
import SectionThingsEveryParentShouldKnowVariant from "./sections/SectionThingsEveryParentShouldKnow/variant";
import SectionIncredibleHealthBenefitsVariant from "./sections/SectionIncredibleHealthBenefits/variant";
import SectionRecipeComparisonVariant from "./sections/SectionRecipeComparison/variant";

export default function LandingPageBodyVariant() {

  return (
    <div className="flex flex-col">
      { /* Section 1: Quality Origins */ }
      <SectionQualityOrigins />

      { /* Section 2: Cats are carnivores */ }
      <SectionCatsAreCarnivoresVariant />

      { /* Section 3: Things every cat parent should know */ }
      <SectionThingsEveryParentShouldKnowVariant />

      { /* Section 3: Recipe Comparison */ }
      <SectionRecipeComparisonVariant />

      { /* Section 4: Incredible Health Benefits */ }
      <SectionIncredibleHealthBenefitsVariant />

      <SectionBrandComparisonTableLandingPageTest
        theme="brand"
        title="KatKin is a fresh approach to cat food"
        body="For less than the price of a daily coffee your cat gets the nutrition it needs for long-term health."
      />

      <SectionImageSplash
        image={{ src: "https://a.storyblok.com/f/176726/958x652/3a8e5035d1/katkin_price-update_150.png/m/1200x0", width: 1432, height: 975 }}
        title={{
          lines: [],
        }}
        hasBorders={true}
      />

      <Section theme="brand-alt" className={themeRootClassMap["brand-alt"]} data-testid="SectionImageSplash-cta">
        <Container>
          <Grid>
            <Column justify="center" align="center">
              <div className="p-4 pb-12">
                <Button to="/sign-up/fresh">Try from £1.99 a day</Button>
              </div>
            </Column>
          </Grid>
        </Container>
      </Section>

      <SectionAnimatedSplit animation="hideInBox" themeTop="brand" themeBottom="light-grey" />

      { /* Section 5: How It Works */ }
      <SectionHowItWorks />

      <Section theme="light-grey" className={themeRootClassMap["light-grey"]} data-testid="SectionHowItWorks-cta">
        <Container>
          <Grid>
            <Column justify="center" align="center">
              <div className="p-4 pb-12">
                <Button to="/sign-up/fresh">Try a fuss-free trial with 20% off</Button>
              </div>
            </Column>
          </Grid>
        </Container>
      </Section>

      { /* Section 6: Free Trial */ }
      <SectionFreeTrial />

      { /* Section 7: FAQ */ }
      <SectionFAQ />
    </div>
  );
}
